import Global from "./global.js";
import Modal from "./modal.js";

const Blog = {
  init: function () {
    this.cacheSelectors();
    console.log("blog");
  },
  cacheSelectors: function () {
    this.btnShowPost = document.getElementById("show-post") || null; 
    if(this.btnShowPost){
      this.btnShowPost.addEventListener("click", () => this.Events.showPosts());
    }
  },
  Events: {
    showPosts: () => {
      const self = Blog;
      const postHide = document.querySelectorAll('.hide-post');
      const postHideQtd = postHide.length;

      if(postHideQtd > 0) {

        for(let i = 0; i <= 2; i++){
          if(postHide[i]){
            postHide[i].classList.remove("flex-none", "hide-post");
          } else{
            break;
          }
        }

        if(postHideQtd <= 3) {
          self.btnShowPost.style.display = 'none';
        }

      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  Global.init();
  Modal.init();
  Blog.init();
});
